import React from 'react'

import './stepper-component.styl'
import { Icon } from '@nazka/nazka.mapframe.components'
import { faCheck } from '@fortawesome/pro-light-svg-icons'

function StepperComponent({ selectedSessionData, completedParts, currentPartId }) {
  const getClassName = (partId) => {
    if (partId === currentPartId) return 'stepper-component__item--current'
    if (completedParts.includes(partId)) return 'stepper-component__item--completed'
    return 'stepper-component__item'
  }
  return (
    <div className="stepper-component">
      {selectedSessionData.parts.map(item => (
        <>
          <div
            className={getClassName(item.id)}
            key={item.id}
          >
            {completedParts.includes(item.id) ? <Icon icon={faCheck} size="16px" /> : `${item.id}`}
          </div>
          {selectedSessionData.parts.length !== item.id && <div className="stepper-component__line" />}
        </>
      ))}
    </div>
  )
}

export default StepperComponent